import SocialLinks from './social-links';
import ContactsArticle from './contacts-article';
import ToastComp from './toast';
import GoogleMap from './google-map'
export { SocialLinks, ContactsArticle, ToastComp };
export default GoogleMap;